// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Details_wrapper__1Tx6m","explorerUrl":"Details_explorerUrl__2AEoK"};